import { all } from 'redux-saga/effects';
import { watchCollaborators } from './collaborator';

export function* watchCollaborator() {
    yield all([watchCollaborators()]);
}
